import { useEffect, useState } from "react";

function computeParts(targetIso) {
  const target = new Date(targetIso).getTime();
  if (Number.isNaN(target)) return null;
  const diff = target - Date.now();
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  }
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff / 3_600_000) % 24);
  const minutes = Math.floor((diff / 60_000) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds, done: false };
}

/**
 * Countdown — live count-down to a target ISO datetime.
 * Renders 4 blocks (Days · Hours · Minutes · Seconds) in Pan-African luxury styling.
 */
export default function Countdown({ target, label = "Time Until The Ball", testId }) {
  const [parts, setParts] = useState(() => computeParts(target));

  useEffect(() => {
    setParts(computeParts(target));
    const t = setInterval(() => setParts(computeParts(target)), 1000);
    return () => clearInterval(t);
  }, [target]);

  if (!parts) return null;

  const blocks = [
    ["Days", parts.days],
    ["Hrs", parts.hours],
    ["Min", parts.minutes],
    ["Sec", parts.seconds],
  ];

  return (
    <div className="mt-6" data-testid={testId || "countdown"}>
      <div className="label-eyebrow flex items-center gap-2" style={{ fontSize: "0.6rem" }}>
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-bdu-gold animate-pulse" />
        {parts.done ? "The Ball Has Begun" : label}
      </div>
      <div className="mt-4 grid grid-cols-4 gap-2 sm:gap-3 max-w-md">
        {blocks.map(([lbl, val]) => (
          <div
            key={lbl}
            className="border border-bdu-gold/25 bg-black/40 px-2 sm:px-4 py-3 sm:py-4 text-center backdrop-blur-sm"
            data-testid={`countdown-${lbl.toLowerCase()}`}
          >
            <div className="font-serif text-3xl sm:text-4xl text-bdu-gold tabular-nums leading-none">
              {String(val).padStart(2, "0")}
            </div>
            <div className="mt-2 text-[0.55rem] tracking-[0.24em] uppercase text-bdu-cream/50">{lbl}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
